import CheckboxesGroup from 'src/components/CheckboxesGroup';
import Collapsible from 'src/components/Collapsible';

import { useDomainsForFiltersQuery } from './filtersApi';
import { selectedCountLabel } from './selectedCountLabel';

type FilterByGoalDomainsProps = {
  value?: string[];
  onChange: (v?: string[]) => void;
  separator?: boolean;
  studentId?: string;
};

const FilterByGoalDomains = ({
  value,
  onChange,
  separator = true,
  studentId,
}: FilterByGoalDomainsProps) => {
  const { data: domains } = useDomainsForFiltersQuery(studentId ?? '');

  return (
    <Collapsible
      title={`Domain${selectedCountLabel(value)}`}
      separator={separator}
      defaultOpen={false}
    >
      <div className="grid grid-cols-2 gap-x-6 gap-y-2">
        <CheckboxesGroup
          value={value}
          onChange={onChange}
          options={domains?.map((s) => ({
            label: s.name,
            value: s.id,
          }))}
        />
      </div>
    </Collapsible>
  );
};

export default FilterByGoalDomains;
